import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import { formatMillionsNumber } from '~/modules/artist-roster/utils/formatMillionsNumber';

import { streamingBenchmarks } from './mockData';

export function TrackPreReleaseBenchmarks({
  className,
}: {
  className?: string;
}) {
  const { t } = useTranslation('roster');

  return (
    <div className={cn('flex items-center gap-md', className)}>
      <div className="basis-full">
        <div className="mb-xs text-body-md font-semibold text-tertiary-default">
          {formatMillionsNumber(streamingBenchmarks.firstWeek)}
        </div>
        <div className="text-body-sm">
          {t('trackPreReleaseList.streamingBenchmarks.firstWeek')}
        </div>
      </div>
      <div className="basis-full">
        <div className="mb-xs text-body-md font-semibold text-tertiary-default">
          {formatMillionsNumber(streamingBenchmarks.secondWeek)}
        </div>
        <div className="text-body-sm">
          {t('trackPreReleaseList.streamingBenchmarks.secondWeek')}
        </div>
      </div>
      <div className="basis-full">
        <div className="mb-xs text-body-md font-semibold text-tertiary-default">
          {formatMillionsNumber(streamingBenchmarks.firstYear)}
        </div>
        <div className="text-body-sm">
          {t('trackPreReleaseList.streamingBenchmarks.firstYear')}
        </div>
      </div>
    </div>
  );
}

TrackPreReleaseBenchmarks.displayName = 'TrackPreReleaseBenchmarks';
